import React from 'react';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import Tooltip from '../../../../../common/components/Tooltip';
import './_styles.scss';

function EdgeFirmwareVersionField({ label, value = null, releaseNotes = null, onViewReleaseNotes = null }) {
  const tooltipTitle = releaseNotes ? `${releaseNotes.title || releaseNotes.version || ''}` : '';

  return (
    <div className="staticField">
      <div className="label">
        {label}
        <div className="value firmware-version-field">
          <span className="firmware-version">{value}</span>
          {releaseNotes && (
            <Tooltip title={tooltipTitle} arrow>
              <InfoOutlinedIcon
                className="release-notes-icon"
                onClick={onViewReleaseNotes}
                role="button"
                tabIndex={0}
                aria-label="View release notes"
                fontSize="small"
              />
            </Tooltip>
          )}
        </div>
      </div>
    </div>
  );
}

export default EdgeFirmwareVersionField;
